import { QUERY_KEYS } from "../../lib/query-constants"
import { useGenericQuery } from "../use-generic-query"


export const useLeadSources = ({ endpoint = "leadsource/options" }) => {
    return useGenericQuery({
        queryKey: QUERY_KEYS.leadSourceOptions.all,
        endpoint: endpoint,
        onError: () => { },
        onSuccess: () => { },
        staleTime: Infinity,
    })
}